import _ from 'lodash'
import moment from "moment";
import dayjs from 'dayjs';
import duration, { Duration } from 'dayjs/plugin/duration'
import localeData from 'dayjs/plugin/localeData'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/zh-cn'
import 'dayjs/locale/en'
import VueI18n from 'vue-i18n';

dayjs.extend(duration)
dayjs.extend(localeData)
dayjs.extend(relativeTime)

export function updateDayLocale(locale) {
    if (locale == 'cn') {
        dayjs.locale('zh-cn')
    } else {
        dayjs.locale('en')
    }
}

export function humanizeDurationMs(ms: number) {
    return dayjs.duration(ms, 'ms').humanize()
}

export function humanizeDurationS(s: number) {
    return dayjs.duration(s, 'seconds').humanize()
}

export function formatMonth(date?: Date | string) {
    return moment(date).format('YYYY-MM')
}

export function formatDateTime(date?: Date | string) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss')
}

export function formatDateTimeBegin(date?: Date | string) {
    return moment(date).format('YYYY-MM-DD 00:00:00')
}

export function formatDateTimeEnd(date?: Date | string) {
    return moment(date).format('YYYY-MM-DD 23:59:59')
}


export function formatDate(date?: Date | string) {
    return moment(date).format('YYYY-MM-DD')
}

export function formatDateTime1(date?: Date | string) {
    return moment(date).format('YYYY/MM/DD HH:mm:ss')
}

export function formatDateTimeBegin1(date?: Date | string) {
    return moment(date).format('YYYY/MM/DD 00:00:00')
}

export function formatDateTimeEnd1(date?: Date | string) {
    return moment(date).format('YYYY/MM/DD 23:59:59')
}

export function lastWeekRange() {
    return [moment().subtract(7, 'days').format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')]
}

export function nextWeekRange() {
    return [moment().format('YYYY-MM-DD 00:00:00'), moment().add(7, 'days').format('YYYY-MM-DD 23:59:59')]
}

export function lastNHourRange(n: number) {
    return [moment().subtract(n, 'hours').format('YYYY-MM-DD HH:mm:ss'), moment().format('YYYY-MM-DD HH:mm:ss')]
}

export function last24HourRange() {
    return [moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss'), moment().format('YYYY-MM-DD HH:mm:ss')]
}

export function todayRange() {
    return [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')]
}

export function lastDayRange() {
    return [moment().subtract(1, 'days').format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')]
}

export function lastDayRange2() {
    return [moment().subtract(1, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
}

export function lastDayTimeRange() {
    return [moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss'), moment().format('YYYY-MM-DD HH:mm:ss')]
}


export function lastNDayRange(n: number) {
    return [moment().subtract(n, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
}

export function lastMonthRange() {
    return [moment().subtract(1, 'months').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
}

export function monthRange(month: string) {
    let start = moment(month, 'YYYY-MM')
    let end = moment(month, 'YYYY-MM').endOf('month')
    if (moment().isBefore(end)) {
        end = moment()
    }
    return [start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD')]
}

export function dateTimeRangeHour(datetime: string, rangeHour: number) {
    let start = moment(datetime).subtract(rangeHour, 'hour').format('YYYY-MM-DD HH:mm:ss')
    let end = moment(datetime).add(rangeHour, 'hour').format('YYYY-MM-DD HH:mm:ss')
    return [start, end]
}

export function rangeDayTime(time: string) {
    let start = moment(time).subtract(12, 'hour').format('YYYY-MM-DD HH:mm:ss')
    let end = moment(time).add(12, 'hour').format('YYYY-MM-DD HH:mm:ss')
    return [start, end]
}

export function rangeWeekTime(time: string) {
    let start = moment(time).subtract(3, 'day').format('YYYY-MM-DD HH:mm:ss')
    let end = moment(time).add(4, 'day').format('YYYY-MM-DD HH:mm:ss')
    return [start, end]
}

export function rangeMonthTimeBefore(time: string, n: number = 1) {
    let start = moment(time).subtract(1, 'month').format('YYYY-MM-DD HH:mm:ss')
    let end = moment(time).format('YYYY-MM-DD HH:mm:ss')
    return [start, end]
}

export function rangeMonthTime(time: string, n: number = 1, trimToday = true) {
    let start = moment(time).subtract(n, 'month').format('YYYY-MM-DD HH:mm:ss')
    let end = moment(time).add(n, 'month').format('YYYY-MM-DD HH:mm:ss')
    return [start, end]
}

export function makeForeverDate() {
    return [formatDate(), '9999-12-31']
}

export const DefaultTime = ['00:00:00', '23:59:59']


export function formatAudioTime(seconds) {
    if (isNaN(seconds)) return '...';
    const milliseconds = Math.trunc((seconds % 1) * 1000)
    let ms = milliseconds.toString()
    if (ms.length == 1) {
        ms = '00' + ms
    } else if (ms.length == 2) {
        ms = '0' + ms
    }
    const minutes = Math.floor(seconds / 60);
    seconds = Math.floor(seconds % 60);
    if (seconds < 10) seconds = '0' + seconds;
    return `${minutes}:${seconds}:${ms}`;
}

export function diffDuration(end, start) {
    let s = dayjs(start)
    let e = dayjs(end)
    let diff = e.diff(s)
    return dayjs.duration(diff)
}

export function formatMonthDay(time) {
    return moment(time).format('MM-DD')
}

export function formatDurationSeconds(seconds: number, i18n: VueI18n) {
    let d = dayjs.duration(seconds, 'seconds')
    return formatDuration(d, i18n)
}

function formatDurationPart(value: number, unitKey: string, i18n: VueI18n) {
    const unit = i18n.t(unitKey) as string
    const separator = i18n.locale === 'cn' ? '' : ' '
    return `${value}${separator}${unit}`
}

export function formatDuration(d: Duration, i18n: VueI18n) {
    let res = []
    if (d.years()) {
        res.push(formatDurationPart(d.years(), 'unit.year', i18n))
    }
    if (d.months()) {
        res.push(formatDurationPart(d.months(), 'unit.month', i18n))
    }
    if (d.days()) {
        res.push(formatDurationPart(d.days(), 'unit.days', i18n))
    }
    if (d.hours()) {
        res.push(formatDurationPart(d.hours(), 'unit.hours', i18n))
    }
    if (d.minutes()) {
        res.push(formatDurationPart(d.minutes(), 'unit.minutes', i18n))
    }
    if (d.seconds()) {
        res.push(formatDurationPart(d.seconds(), 'unit.seconds', i18n))
    }
    return res.join(i18n.locale === 'cn' ? '' : ', ')
}
